<template>
  <div>
    <cart-item :goodsType="goods_type" :info.sync="item" v-for="(item,index) in list" :key="index"></cart-item>
    <p class="pelac_hode" :style="{height:remind?'5rem':'2.8rem'}"></p>
    <div class="order-tips" v-if="remind">
      <div class="stip">{{remind}}</div>
      <Iconfont name="iconx" size="0.8rem" color="#FC3E3E" @click="remind=''"></Iconfont>
    </div>
    <div class="static flex_b w100">
      <div class="bleft flex">
        <div class="bjf">
          <div>
            <span style="font-size: 0.56rem" class="hj">合计：</span>
            <span class="jf">{{jinbi}}</span>
            <span class="jftip">积分</span>
          </div>
          <div class="express" v-if="goods_type!=2">快递运费：{{yf_amount}}元</div>
          <!--<div class="express">物流运费（预估）：15元（到付）</div>-->
        </div>
      </div>
      <div class="bright" @click="goAccount">提交订单</div>
    </div>
    <mloading v-if="showLoading"></mloading>
  </div>
</template>

<script>
import cartItem from '@/components/cartItem.vue'
import { sendRequest } from '@/assets/public'
import mloading from '@/components/loading.vue'
import Iconfont from '@/components/iconfont.vue'
import { Toast } from 'vant'

export default {
  components: { cartItem, mloading, Iconfont },
  name: 'orderConfirm',
  data() {
    return {
      list: [],
      jinbi: 0,
      yf_amount: 0,
      ids: '',
      cart_type: '',
      goods_type: '',
      showLoading: true,
      remind: '', //提示
      isClick:false
    }
  },
  mounted() {
    this.ids = this.$route.params.ids || this.$route.query.ids
    this.cart_type = this.$route.params.cart_type || this.$route.query.cart_type

    this.goods_type =
      this.$route.params.goods_type || this.$route.query.goods_type

    this.getOrder()
    let urlData = this.showWindowHref()
    this.code = urlData['code']
  },
  methods: {
    // 获取订单
    async getOrder() {
      this.showLoading = true
      let { content } = await sendRequest('cart/confirmList', {
        order_ids: this.ids,
        cart_type: this.cart_type,
      })
      this.showLoading = false
      this.remind = content ? content.remind : ''
      this.list = content ? content.list : []
      this.jinbi = content ? content.dhb_total : 0
      this.yf_amount = content ? content.yf_amount : 0
    },
    async goAccount() {
      this.showLoading = true
      if(this.isClick) return
      this.isClick=true
      let { status, content, msg } = await sendRequest('cart/submitOrder', {
        order_ids: this.ids,
        cart_type: this.cart_type,
      })
      this.showLoading = false
      if (status == 200) {
         this.isClick=false
        // window.location.href = '/account?order_sn='+content.order_sn
        // this.$router.go(-1)
        setTimeout(() => {
          this.$router.replace({
            name: 'account',
            query: {
              order_sn: content.order_sn,
              goods_type: this.goods_type,
            },
          })
        }, 10)
      } else {
         this.isClick=false
        Toast(msg)
      }
    },
  },
}
</script>

<style scoped>
.order-tips {
  width: calc(100% - 1.2rem);
  padding: 0.6rem;
  background: #fff5d6;
  color: #fc3e3e;
  font-size: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  bottom: 2.3rem;
}

.stip {
  width: 12.56rem;
}

.pelac_hode {
  height: 2.8rem;
}

.static {
  position: fixed;
  bottom: 0rem;
  left: 0;
}

.bleft {
  width: 10.56rem;
  height: 2.3rem;
  padding-left: 0.8rem;
  background: #fff;
  align-items: center;
}

.bright {
  width: 3.64rem;
  height: 2.3rem;
  background: #fd3e3e;
  text-align: center;
  line-height: 2.3rem;
  font-size: 0.6rem;
  color: #fff;
}

.bjf {
  text-align: left;
  padding-bottom: 0.3rem;
}

.bjf .hj {
  font-size: 0.56rem;
}

.bjf .jf {
  font-size: 0.6rem;
  color: #fd3e3e;
}

.bjf .jftip {
  font-size: 0.44rem;
  color: #fd3e3e;
}

.bjf .express {
  font-size: 0.44rem;
  color: #999;
}
</style>